import { AdminDashboard2Component } from './../admin/admin-dashboard2/admin-dashboard2.component';
import { AdminDashboard1Component } from './../admin/admin-dashboard1/admin-dashboard1.component';
import { StarterComponent } from './../starter/starter.component';
import { AdminComponent } from './../admin/admin.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/* GUARDS */
import { LoginGuard } from './../guards/login-guard';
/* END GUARDS */

import { LoginComponent } from './../pages/login/login.component';
import { HomeComponent } from './../pages/home/home.component';
import { BalancesComponent } from './../pages/balances/balances.component';
import { ClientListComponent } from './../pages/client-list/client-list.component';
import { ClientMapComponent } from './../pages/client-map/client-map.component';
import { CreditListComponent } from './../pages/credit-list/credit-list.component';
import { AuthorizationListComponent } from './../pages/authorization-list/authorization-list.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', redirectTo: 'v1', pathMatch: 'full' },
      { 
        path: 'v1', 
        component: StarterComponent, 
        canActivate: [LoginGuard],
        children: [
      		{
            path: '',
            redirectTo: 'clients',
            //component: HomeComponent,
            pathMatch: 'full'
          },
          {
	      		path: 'balances',
	      		component: BalancesComponent,
          },
          {
	      		path: 'clients',
	      		component: ClientListComponent,
          },
          {
	      		path: 'client-map',
	      		component: ClientMapComponent,
          },
          
          {
	      		path: 'credits',
	      		component: CreditListComponent,
          },
          {
	      		path: 'authorizations',
            component: AuthorizationListComponent
          },
        ]
      },
      {
      	path: 'login',
      	component: LoginComponent,
      },
    ])
  ],
  declarations: [],
  exports: [ RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/app-routing/app-routing.module.ts